(function () {
  'use strict';

  var BASE_CURRENCY = 'USD';
  var updateTimer = null;
  var isUpdating = false;

  function getActiveCurrency(cart) {
    return (
      cart && cart.currency
    ) || (
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
    ) || BASE_CURRENCY;
  }

  function getShopifyCurrencyRate(activeCurrency) {
    if (activeCurrency === BASE_CURRENCY) {
      return 1;
    }

    if (
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active === activeCurrency &&
      window.Shopify.currency.rate &&
      isFinite(Number(window.Shopify.currency.rate))
    ) {
      return Number(window.Shopify.currency.rate);
    }

    return null;
  }

  function getCartUrl() {
    var root = '/';

    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      root = window.Shopify.routes.root;
    }

    return root + 'cart.js';
  }

  function formatMoney(cents, currency) {
    var locale = document.documentElement.lang || navigator.language || 'en-US';
    var amount = Number(cents) / 100;

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  function getProgressPercent(cartTotalCents, thresholdCents) {
    if (!thresholdCents || thresholdCents <= 0) {
      return 0;
    }

    var percentage = cartTotalCents * 100 / thresholdCents;

    if (percentage > 10 && percentage < 100) {
      percentage = percentage - 5;
    } else if (percentage > 100) {
      percentage = 100;
    }

    if (percentage < 0) {
      percentage = 0;
    }

    return percentage;
  }

  function getEstimatedShippingCents(footer, cart, currencyRate) {
    if (cart.requires_shipping === false) return 0;

    var cartTotalBaseCents = Number(cart.total_price || 0) / currencyRate;
    var matchedTier = null;

    footer.querySelectorAll('[data-cart-shipping-tier]').forEach(function (tier) {
      var minimum = Number(tier.dataset.minCents || 0);
      var maximumValue = tier.dataset.maxCents;
      var maximum = maximumValue === '' ? Infinity : Number(maximumValue);

      if (cartTotalBaseCents >= minimum) {
        matchedTier = tier;
      }

      if (cartTotalBaseCents >= minimum && cartTotalBaseCents <= maximum) {
        matchedTier = tier;
      }
    });

    if (!matchedTier) return 0;

    return Math.max(0, Math.round(Number(matchedTier.dataset.priceCents || 0) * currencyRate));
  }

  function updateCartFooter(footer, cart) {
    if (!footer || !cart) return;

    var activeCurrency = getActiveCurrency(cart);
    var currencyRate = getShopifyCurrencyRate(activeCurrency);

    if (!currencyRate) return;

    var shippingCents = getEstimatedShippingCents(footer, cart, currencyRate);
    var shippingTiersEnabled = footer.dataset.estimatedShippingEnabled !== 'false';
    var estimatedTotalCents = Number(cart.total_price || 0) + (shippingTiersEnabled ? shippingCents : 0);
    var shippingRow = footer.querySelector('[data-cart-estimated-shipping-row]');
    var shippingElement = footer.querySelector('[data-cart-estimated-shipping]');
    var estimatedTotalElement = footer.querySelector('[data-cart-estimated-total]');
    var checkoutTotalElement = footer.querySelector('[data-cart-checkout-total]');
    var isFree = shippingCents <= 0;

    if (shippingRow) {
      shippingRow.classList.toggle('hidden', !shippingTiersEnabled && (!isFree || cart.requires_shipping === false));
    }

    if (shippingElement) {
      shippingElement.textContent = isFree
        ? (footer.dataset.shippingFreeText || 'Free')
        : '+' + formatMoney(shippingCents, activeCurrency);
      shippingElement.classList.toggle('is-free', isFree);
    }

    if (estimatedTotalElement) {
      estimatedTotalElement.textContent = formatMoney(estimatedTotalCents, activeCurrency);
    }

    if (checkoutTotalElement) {
      checkoutTotalElement.textContent = formatMoney(estimatedTotalCents, activeCurrency);
    }
  }

  function getCartInfoModal(trigger) {
    var drawer = trigger && trigger.closest('[data-cart-drawer]');
    var modalKey = trigger && trigger.getAttribute('data-cart-info-modal-open');

    return drawer && modalKey
      ? drawer.querySelector('[data-cart-info-modal="' + modalKey + '"]')
      : null;
  }

  function openCartInfoModal(trigger) {
    var modal = getCartInfoModal(trigger);

    if (!modal || modal.open || typeof modal.showModal !== 'function') return;

    modal.showModal();
  }

  function updateLoyaltyLoginLinks() {
    document.querySelectorAll('[data-cart-drawer]').forEach(function (drawer) {
      var loginUrl = drawer.dataset.loyaltyLoginUrl;
      var loginLabel = drawer.dataset.loyaltyLoginLabel;

      drawer.querySelectorAll('.honeypop-cp').forEach(function (widget) {
        var existingLink = widget.querySelector('[data-cart-loyalty-login]');
        var shouldShow = Boolean(loginUrl && loginLabel && widget.dataset.loggedIn === 'false');

        if (!shouldShow) {
          if (existingLink) existingLink.remove();
          return;
        }

        var widgetHeader = widget.querySelector('.honeypop-cp-header');

        if (!widgetHeader || existingLink) return;

        var loginLink = document.createElement('a');
        loginLink.href = loginUrl;
        loginLink.className = 'honeypop-cp-login';
        loginLink.dataset.cartLoyaltyLogin = '';
        loginLink.textContent = loginLabel;
        loginLink.addEventListener('click', function (event) {
          event.stopPropagation();
        });
        widgetHeader.appendChild(loginLink);
      });
    });
  }

  function updateLoyaltyInfoButtons() {
    document.querySelectorAll('[data-cart-drawer]').forEach(function (drawer) {
      var modal = drawer.querySelector('[data-cart-info-modal="loyalty"]');
      var modalTitle = modal && modal.querySelector('[id]');

      drawer.querySelectorAll('.honeypop-cp').forEach(function (widget) {
        var existingButton = widget.querySelector('[data-cart-info-modal-open="loyalty"]');
        var headline = widget.querySelector('.honeypop-cp-headline');

        if (!modal) {
          if (existingButton) existingButton.remove();

          var existingRow = headline && headline.closest('.honeypop-cp-headline-row');
          if (existingRow) {
            existingRow.insertAdjacentElement('beforebegin', headline);
            existingRow.remove();
          }

          return;
        }

        if (!headline) return;

        var headlineRow = headline.closest('.honeypop-cp-headline-row');

        if (!headlineRow) {
          headlineRow = document.createElement('div');
          headlineRow.className = 'honeypop-cp-headline-row';
          headline.insertAdjacentElement('beforebegin', headlineRow);
          headlineRow.appendChild(headline);
        }

        if (existingButton) {
          if (existingButton.parentElement !== headlineRow) {
            headlineRow.appendChild(existingButton);
          }
          return;
        }

        var infoButton = document.createElement('button');
        infoButton.type = 'button';
        infoButton.className = 'cart-drawer-footer__info honeypop-cp-info';
        infoButton.dataset.cartInfoModalOpen = 'loyalty';
        infoButton.setAttribute('aria-label', modalTitle ? modalTitle.textContent.trim() : 'Information');
        infoButton.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6"></circle><path d="M12 10.7v6M12 7.2v.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path></svg>';
        headlineRow.appendChild(infoButton);
      });
    });
  }

  function parseLoyaltyPoints(text) {
    var match = String(text || '').replace(/\u00a0/g, ' ').match(/[+-]?\s*([0-9][0-9\s.,]*)/);
    if (!match) return null;

    var points = Number(match[1].replace(/[^0-9]/g, ''));
    return isFinite(points) ? points : null;
  }

  function formatRewardMoney(cents, currency) {
    var locale = document.documentElement.lang || navigator.language || 'en-US';
    var roundedCents = Math.round(Number(cents) || 0);
    var hasFraction = Math.abs(roundedCents % 100) > 0;

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: hasFraction ? 2 : 0,
        maximumFractionDigits: 2
      }).format(roundedCents / 100);
    } catch (error) {
      return (roundedCents / 100).toFixed(hasFraction ? 2 : 0) + ' ' + currency;
    }
  }

  function matchesPointsTemplate(text, template) {
    if (!template || template.indexOf('{points}') === -1) return true;

    var parts = template.split('{points}');
    var prefix = (parts[0] || '').trim();
    var suffix = (parts.slice(1).join('{points}') || '').trim();
    var normalizedText = String(text || '').trim();

    if (prefix && normalizedText.indexOf(prefix) !== 0) return false;
    if (suffix && normalizedText.slice(-suffix.length) !== suffix) return false;

    return true;
  }

  function getLoyaltyRewardSuffix(widget, template) {
    if (!template || template.indexOf('{points}') === -1) return '';

    var suffix = template.split('{points}').slice(1).join('{points}').trim();
    var pointsLabel = (widget.dataset.pointsLabel || '').trim();

    if (pointsLabel && suffix.indexOf(pointsLabel) === 0) {
      suffix = suffix.slice(pointsLabel.length).trim();
    }

    return suffix;
  }

  function restoreLoyaltyRewardValue(widget, headline) {
    var renderedText = headline.dataset.loyaltyMoneyText || '';
    var sourcePoints = headline.dataset.loyaltySourcePoints;
    var currentText = (headline.textContent || '').trim();
    var pointsTemplate = widget.dataset.loggedIn === 'true'
      ? widget.dataset.loggedInText
      : widget.dataset.loggedOutHeadline;

    if (
      renderedText &&
      currentText === renderedText &&
      sourcePoints != null &&
      pointsTemplate &&
      pointsTemplate.indexOf('{points}') !== -1
    ) {
      headline.textContent = pointsTemplate.replace('{points}', sourcePoints);
    }

    delete headline.dataset.loyaltySourcePoints;
    delete headline.dataset.loyaltyMoneyText;
  }

  function updateLoyaltyRewardValues(cart) {
    document.querySelectorAll('[data-cart-drawer] .honeypop-cp').forEach(function (widget) {
      var headline = widget.querySelector('.honeypop-cp-headline');
      if (!headline) return;

      var drawer = widget.closest('[data-cart-drawer]');

      if (!drawer || drawer.dataset.loyaltyConvertToMoney !== 'true') {
        restoreLoyaltyRewardValue(widget, headline);
        return;
      }

      var activeCurrency = getActiveCurrency(cart);
      var currencyRate = getShopifyCurrencyRate(activeCurrency);

      if (!currencyRate) return;

      var currentText = (headline.textContent || '').trim();
      var lastRenderedText = headline.dataset.loyaltyMoneyText || '';
      var pointsTemplate = widget.dataset.loggedIn === 'true'
        ? widget.dataset.loggedInText
        : widget.dataset.loggedOutHeadline;

      if (currentText !== lastRenderedText) {
        if (!matchesPointsTemplate(currentText, pointsTemplate)) {
          delete headline.dataset.loyaltySourcePoints;
          delete headline.dataset.loyaltyMoneyText;
          return;
        }

        var currentPoints = parseLoyaltyPoints(currentText);
        if (currentPoints !== null) headline.dataset.loyaltySourcePoints = String(currentPoints);
      }

      var sourcePoints = Number(headline.dataset.loyaltySourcePoints);
      if (!isFinite(sourcePoints)) return;

      var currentCurrencyCents = Math.round(sourcePoints * currencyRate);
      var rewardSuffix = getLoyaltyRewardSuffix(widget, pointsTemplate);
      var renderedText = '+' + formatRewardMoney(currentCurrencyCents, activeCurrency);

      if (rewardSuffix) renderedText += ' ' + rewardSuffix;

      headline.dataset.loyaltyMoneyText = renderedText;
      if (currentText !== renderedText) headline.textContent = renderedText;
    });
  }

  function updateContainer(container, cart) {
    if (!container || !cart) return;

    var thresholdUsdCents = Number(container.dataset.freeShippingThresholdUsdCents);
    var messageTemplate = container.dataset.freeShippingMessage || 'Only ||amount|| left for free shipping';
    var successMessage = container.dataset.freeShippingSuccessMessage || "You've got free shipping!";

    if (!thresholdUsdCents || !isFinite(thresholdUsdCents)) {
      return;
    }

    var activeCurrency = getActiveCurrency(cart);
    var rate = getShopifyCurrencyRate(activeCurrency);

    if (!rate) {
      console.warn('[Free shipping bar] Currency rate not found for:', activeCurrency);
      return;
    }

    var thresholdCurrentCents = Math.round(thresholdUsdCents * rate);
    var cartTotalCents = Number(cart.total_price || 0);
    var remainingCents = thresholdCurrentCents - cartTotalCents;

    var textEl = container.querySelector('[data-free-shipping-text]');
    var barEl = container.querySelector('[data-free-shipping-bar]');
    var includedEl = container.querySelector('[data-free-shipping-included]');

    if (textEl) {
      if (remainingCents > 0) {
        textEl.textContent = messageTemplate.replace(
          '||amount||',
          formatMoney(remainingCents, activeCurrency)
        );
      } else {
        textEl.textContent = successMessage;
      }
    }

    if (barEl) {
      var progress = getProgressPercent(cartTotalCents, thresholdCurrentCents);

      barEl.style.width = progress.toFixed(2) + '%';
      barEl.setAttribute('aria-valuenow', Math.round(progress));
    }

    if (includedEl) {
      includedEl.classList.toggle('hidden', remainingCents > 0);
    }
  }

  function updateFreeShippingBars() {
    var containers = document.querySelectorAll('[data-free-shipping-container]');
    var footers = document.querySelectorAll('[data-cart-footer-summary]');

    if ((!containers.length && !footers.length) || isUpdating) {
      return;
    }

    isUpdating = true;

    fetch(getCartUrl(), {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-free-shipping-container]').forEach(function (container) {
          updateContainer(container, cart);
        });

        document.querySelectorAll('[data-cart-footer-summary]').forEach(function (footer) {
          updateCartFooter(footer, cart);
        });

        updateLoyaltyRewardValues(cart);
      })
      .catch(function (error) {
        console.warn('[Free shipping bar] Cart update failed:', error);
      })
      .finally(function () {
        isUpdating = false;
      });
  }

  function scheduleUpdate(delay) {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(function () {
      updateFreeShippingBars();
    }, typeof delay === 'number' ? delay : 100);
  }

  function scheduleUpdateSeries() {
    scheduleUpdate(50);

    setTimeout(updateFreeShippingBars, 250);
    setTimeout(updateFreeShippingBars, 700);
    setTimeout(updateFreeShippingBars, 1400);
  }

  function isCartRequest(input) {
    var url = '';

    if (typeof input === 'string') {
      url = input;
    } else if (input && input.url) {
      url = input.url;
    }

    return /\/cart\/(add|change|update|clear)(\.js)?/i.test(url);
  }

  function patchFetchForCartUpdates() {
    if (window.__freeShippingFetchPatched || typeof window.fetch !== 'function') {
      return;
    }

    window.__freeShippingFetchPatched = true;

    var originalFetch = window.fetch;

    window.fetch = function () {
      var input = arguments[0];
      var shouldUpdate = isCartRequest(input);

      var promise = originalFetch.apply(this, arguments);

      if (shouldUpdate) {
        promise
          .then(function () {
            scheduleUpdateSeries();
          })
          .catch(function () {
            scheduleUpdateSeries();
          });
      }

      return promise;
    };
  }

  function subscribeToThemeCartUpdates() {
    if (typeof window.subscribe !== 'function') {
      return;
    }

    try {
      window.subscribe('cartUpdate', function () {
        scheduleUpdateSeries();
      });

      window.subscribe('quantityUpdate', function () {
        scheduleUpdateSeries();
      });
    } catch (error) {}
  }

  function observeCartDomChanges() {
    if (!document.body || !window.MutationObserver) {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      var shouldUpdate = false;

      updateLoyaltyLoginLinks();
      updateLoyaltyInfoButtons();
      updateLoyaltyRewardValues();

      mutations.forEach(function (mutation) {
        if (shouldUpdate) return;

        var target = mutation.target;

        if (
          target &&
          target.nodeType === 1 &&
          (
            target.matches('[data-cart-wrapper], [data-cart-drawer-body], [data-free-shipping-container], [data-cart-footer-summary]') ||
            target.querySelector('[data-cart-wrapper], [data-cart-drawer-body], [data-free-shipping-container], [data-cart-footer-summary]')
          )
        ) {
          shouldUpdate = true;
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (shouldUpdate || node.nodeType !== 1) return;

          if (
            node.matches('[data-cart-wrapper], [data-cart-drawer-body], [data-free-shipping-container], [data-cart-footer-summary]') ||
            node.querySelector('[data-cart-wrapper], [data-cart-drawer-body], [data-free-shipping-container], [data-cart-footer-summary]')
          ) {
            shouldUpdate = true;
          }
        });
      });

      if (shouldUpdate) {
        scheduleUpdateSeries();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    patchFetchForCartUpdates();
    subscribeToThemeCartUpdates();
    observeCartDomChanges();
    updateLoyaltyLoginLinks();
    updateLoyaltyInfoButtons();
    updateLoyaltyRewardValues();
    scheduleUpdateSeries();
  });

  window.addEventListener('load', function () {
    scheduleUpdateSeries();
  });

  document.addEventListener('cart:update', scheduleUpdateSeries);
  document.addEventListener('cart:updated', scheduleUpdateSeries);
  document.addEventListener('cart:change', scheduleUpdateSeries);
  document.addEventListener('cart:refresh', scheduleUpdateSeries);
  document.addEventListener('theme:cart:update', scheduleUpdateSeries);
  document.addEventListener('shopify:section:load', scheduleUpdateSeries);

  document.addEventListener('submit', function (event) {
    if (
      event.target &&
      event.target.matches('form[action*="/cart/add"], form[action*="/cart/add.js"]')
    ) {
      scheduleUpdateSeries();
    }
  }, true);

  document.addEventListener('click', function (event) {
    var infoModalTrigger = event.target.closest('[data-cart-info-modal-open]');
    var infoModalClose = event.target.closest('[data-cart-info-modal-close]');
    var infoModal = event.target.closest('[data-cart-info-modal]');

    if (infoModalTrigger) {
      event.preventDefault();
      openCartInfoModal(infoModalTrigger);
      return;
    }

    if (infoModalClose) {
      event.preventDefault();
      infoModalClose.closest('[data-cart-info-modal]').close();
      return;
    }

    if (infoModal && event.target === infoModal) {
      infoModal.close();
      return;
    }

    if (
      event.target.closest('[data-cart-item-remove], [data-quantity-increment], [data-quantity-decrement], #gift_wrap, [data-add-to-cart]')
    ) {
      scheduleUpdateSeries();
    }
  }, true);

  window.updateFreeShippingBars = updateFreeShippingBars;
})();
